import ErrorBoundary from 'dashboard-components/error/ErrorBoundary';
import { SentryEventIds, capture, createFingerprint } from 'dashboard-lib/public/sentry';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const DashboardHeaderErrorBoundary = props => {
  const {
    children,
    dashboardId
  } = props;
  const ErrorComponent = () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboardHeader.errorBoundaryMessage"
  });
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    name: SentryEventIds.DASHBOARD_HEADER_ERROR_BOUNDARY,
    ErrorComponent: ErrorComponent,
    onError: (error, name) => {
      capture(name, {
        error,
        extra: {
          dashboardId
        },
        fingerprint: createFingerprint(error)
      });
    },
    children: children
  });
};